export default __webpack_public_path__ + "autodesk-maya.a979a079.png";